import React, {useEffect, useState} from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import { QueryClient } from '@tanstack/react-query'
import AkScholarshipsComponent from 'ak-scholarships-component'

const AkScholarships = () => {

  const [referrer,setReferrer] = useState()

  useEffect(() => {
    setReferrer(window.location.href)
  }, [])

  const data = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          crmApiUrl
          crmApiToken
          orderApiUrl
          orderApiToken
          scholarshipApiUrl
          tracking {
            mtUrl
            mtId
          }
        }
      }
    }
  `)

  const cfg = data.site.siteMetadata

  const scholarshipConfig = {
    upsell: false,
    upsellPrechecked: false,
    mtId: cfg.tracking.mtId,
    mtUrl: cfg.tracking.mtUrl,
    scholarshipApiUrl: cfg.scholarshipApiUrl,
    orderApiUrl: cfg.orderApiUrl,
    orderApiToken: cfg.orderApiToken,
    crmApiUrl: cfg.crmApiUrl,
    crmApiToken: cfg.crmApiToken,
    referrer: referrer,
  }

  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: Infinity,
      }
    }
  })

  return (
    <AkScholarshipsComponent {...scholarshipConfig} queryClient={queryClient} />
  )
}

export default AkScholarships
